import { render, staticRenderFns } from "./employment_education.vue?vue&type=template&id=56bcdc5c&"
import script from "./employment_education.vue?vue&type=script&lang=js&"
export * from "./employment_education.vue?vue&type=script&lang=js&"
import style0 from "./employment_education.vue?vue&type=style&index=0&id=56bcdc5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports